<template>
  <RadioGroup v-model="model">
    <RadioGroupLabel>
      <p class="text-bold mb-1">Billing Interval</p>
    </RadioGroupLabel>
    <div class="flex flex-col md:flex-row">
      <RadioGroupOption class="grow basis-0" v-slot="{ checked, active }" value="monthly">
        <span
          class="flex gap-2 p-4 border border-neutral-400 dark:border-neutral-700 cursor-pointer rounded-md"
          :class="
            checked
              ? 'border-cardinal-500  dark:bg-white dark:text-neutral-900 dark:border-white bg-neutral-800 text-white'
              : ''
          "
        >
          <div
            class="border border-neutral-600 rounded-full h-5 w-5 relative top-0.5 flex items-center justify-center shrink-0"
          >
            <i
              class="text-sm text-cardinal-500 dark:text-cardinal"
              :class="{
                'fas fa-circle': checked,
                '': !checked,
              }"
            ></i>
          </div>
          <div>
            <strong clas="!font-bold">Monthly - $12.99/mo.</strong>
            <ul class="text-sm list-disc pl-4 mt-2">
              <li>Cancel any time</li>
            </ul>
          </div>
        </span>
      </RadioGroupOption>
      <RadioGroupOption class="grow basis-0" v-slot="{ checked, active }" value="annual">
        <span
          class="flex gap-2 p-4 border border-neutral-400 dark:border-neutral-700 cursor-pointer rounded-md"
          :class="
            checked
              ? 'border-cardinal-500  dark:bg-white dark:text-neutral-900 dark:border-white bg-neutral-800 text-white'
              : ''
          "
        >
          <div
            class="border border-neutral-600 rounded-full h-5 w-5 relative top-0.5 flex items-center justify-center shrink-0"
          >
            <i
              class="text-sm text-cardinal-500 dark:text-cardinal"
              :class="{
                'fas fa-circle': checked,
                '': !checked,
              }"
            ></i>
          </div>
          <div>
            <strong clas="!font-bold">Annual - $9.99/mo. (Best Value)</strong>
            <ul class="text-sm list-disc pl-4 mt-2">
              <li>Save 30%</li>
              <li>Cancel any time</li>
            </ul>
          </div>
        </span>
      </RadioGroupOption>
    </div>
  </RadioGroup>
</template>

<script lang="ts" setup>
import { useVModels } from '@vueuse/core';
// const membershipType = defineModel('membershipType');
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from '@headlessui/vue';
const model = defineModel<string>();
// const props = defineProps<{
//   membershipType: 'portal' | 'standard';
// }>();
// const emit = defineEmits(['update:model']);
// const { membershipType } = useVModels(props, emit);
</script>
